/**
 * Round with 2 numbers after dot
 * @param value
 * @returns {string}
 */
export const roundAsString = (value) => {
  if (!value) return '0';
  return (Math.round(+value * 100) / 100).toFixed(2).replace('.', ',');
};